import type { ReactNode } from "react";

type AgentChatLayoutProps = {
	header: ReactNode;
	children: ReactNode;
};

export function AgentChatLayout({ header, children }: AgentChatLayoutProps) {
	return (
		<div className="flex h-full min-h-0 flex-col overflow-hidden bg-surface-default">
			{header}
			<div className="flex min-h-0 flex-1 flex-col overflow-hidden bg-surface-default">
				{children}
			</div>
		</div>
	);
}
